// src/utils/browser/isSafari.ts
export function isSafari(): boolean {
  if (typeof window === "undefined") return false;

  const ua = navigator.userAgent;
  return (
    ua.includes("Safari") &&
    !ua.includes("Chrome") &&
    !ua.includes("Chromium") &&
    !ua.includes("Android")
  );
}
